import { screenSizes } from 'src/assets/styles/Literals';

// Mobile detection utility
export const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    window.innerWidth <= parseInt(screenSizes.mobile)
  );
};

// Get type label in Spanish
export const getTypeLabel = (type) => {
  const labels = {
    text: 'Texto',
    video: 'Video',
    pdf: 'PDF',
    link: 'Enlace',
    quiz: 'Encuesta',
  };
  return labels[type] || type;
};

// Check if entry is read by user
export const isEntryReadByUser = (entry, currentUserId) => {
  if (!entry || !currentUserId) return false;
  const readedBy = entry.readed_by || [];
  return Array.isArray(readedBy) && readedBy.includes(currentUserId);
};
